module.exports = __webpack_public_path__ + "img/icon-arrow-right.57983fb3.svg";